import * as Type from 'library/ts/utilities/modules/Type';

/**
 * @description Request full screen mode
 * Find the right method, call on correct element
 * @param element {HTMLElement}
 */
export const launch = ( element: HTMLElement | any ): void => {
	if ( Type.isElement( element ) && fullScreenEnabled() === true ) {
		if ( element?.requestFullscreen ) {
			element.requestFullscreen();
		} else if ( element?.mozRequestFullScreen ) {
			element.mozRequestFullScreen();
		} else if ( element?.webkitRequestFullscreen ) {
			element.webkitRequestFullscreen();
		} else if ( element?.msRequestFullscreen ) {
			element.msRequestFullscreen();
		}
	}
};

/**
 * @description Request exit from full screen mode
 */
export const exit = (): void => {
	if ( state().active === false ) return; // sanity check
	const doc: Document | any = document;

	if ( doc.exitFullscreen ) {
		doc.exitFullscreen();
	} else if ( doc?.mozCancelFullScreen ) {
		doc.mozCancelFullScreen();
	} else if ( doc?.webkitExitFullscreen ) {
		doc.webkitExitFullscreen();
	} else if ( doc?.msExitFullscreen ) {
		doc.msExitFullscreen();
	}
};

/**
 * @description Returns current state of full screen: full screen element (or undefined), is full screen enabled
 * @returns {{enabled: Boolean | *, active: Boolean, element: HTMLElement|*}}
 */
export const state = (): { enabled: boolean, active: boolean, element: HTMLElement } => {
	let fullScreenElement = document?.fullscreenElement || document?.[ 'mozFullScreenElement' ] || document?.[ 'webkitFullscreenElement' ] || document?.[ 'msFullscreenElement' ];
	if ( fullScreenElement === null ) fullScreenElement = undefined; // sanity check against document.msFullscreenElement that returns null
	return {
		active: Type.isDefined( fullScreenElement ),
		element: fullScreenElement,
		enabled: fullScreenEnabled()
	};
};

/**
 * @description Returns fullscreenEnabled flag per browser
 * @returns {boolean}
 */
export const fullScreenEnabled = (): boolean => {
	return (
		/* Standard syntax */
		document?.fullscreenEnabled
		||
		/* Chrome, Safari and Opera */
		document?.[ 'webkitFullscreenEnabled' ]
		||
		/* Firefox */
		document?.[ 'mozFullScreenEnabled' ]
		||
		/* IE/Edge */
		document?.[ 'msFullscreenEnabled' ]
	);
};